import React from 'react';
import PropTypes from 'prop-types';

import LargeError from './largeError.jsx';

const RufsError = ({ children }) => (
    <LargeError
        heading="Beklager, nå er det rusk i maskineriet"
        imageSrc="/static/images/500.jpg"
    >
        {children}
    </LargeError>
);

RufsError.propTypes = {
    children: PropTypes.node.isRequired,
};

export default RufsError;



// WEBPACK FOOTER //
// ./safeTrade/errors/rufsError.jsx